import { IStore } from '../../store';
import { TORB4Actions } from './actions';
import { IAuthActions } from '../auth/actions';
import orb4HistoryMiddleware from './middlewares/history.middleware';
import createMiddleware from '../../_core/create-middleware';
// import orb4RestrictionsMiddleware from './middlewares/restrictions.middleware';

const orb4BaseMiddleware = createMiddleware<
    IStore,
    TORB4Actions | IAuthActions
>()
    .getMiddleware();

const orb4Middlewares = [
    orb4BaseMiddleware,
    orb4HistoryMiddleware,
];

export default orb4Middlewares;
